<template>
  <div class="about">
		<div class="pg-header">
			<div>
				<label class="title" v-text="pageTitle"></label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>患者管理</span>|
					<span class="active">患者分组</span>|
					<span v-text="pageTitle"></span>
				</div>
				<a class="back noline" @click="goBack">返回</a>
			</div>
		</div>

		<div class="collapse-wrap" :class="{active: isExpanded}">

			<div class="search-bar">
				<el-form ref="form" label-width="140px">
				<div class="def-key">
					<label>姓名<el-input size="small" placeholder="姓名" maxlength="6" style="width:80px" v-model.trim="filter.name" @keyup.enter.native="handleFilter('search')"></el-input></label>
					<label>身份证号<el-input size="small" placeholder="身份证号" maxlength="18" style="width:160px" v-model.trim="filter.cardNum" @keyup.enter.native="handleFilter('search')"></el-input></label>
					<label>联系电话<el-input size="small" placeholder="联系电话" maxlength="11" style="width:120px" v-model="filter.phone" @keyup.enter.native="handleFilter('search')"></el-input></label>
					<label>入组时间
						<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.date" :picker-options="pickerOptions" @change="handleFilter(2, $event)"></el-date-picker>
					</label>
					<el-button size="mini" icon="el-icon-search" round  @click="handleFilter('search')">搜索</el-button>
					<el-button class="btn-export" size="mini" round @click="exportReport" style="margin-right: 10px;"><i class="icon-export"></i>导出</el-button>
					<el-button class="btn-collapse flr" size="mini" round @click="toggleCollapse" v-if="!isExpanded">展开筛选<i class="icon-expand"></i></el-button>
					<el-button class="btn-collapse flr" size="mini" round @click="toggleCollapse" v-else>收起筛选<i class="icon-collapse"></i></el-button>
				</div>
				<div class="more-key">
					<el-form-item label="性别">						
						<span class="key-opt" :class="{active: filter.sex == 1}" @click="handleFilter('sex', 1)">男<i class="el-icon-close"></i></span>
						<span class="key-opt" :class="{active: filter.sex == 2}" @click="handleFilter('sex', 2)">女<i class="el-icon-close"></i></span>
					</el-form-item>
					<el-form-item label="年龄">
						<el-input size="small" maxlength="3" style="width:60px" v-model.number="filter.ageStart"></el-input>-<el-input size="small" maxlength="3" style="width:60px" v-model.number="filter.ageEnd"></el-input>岁
						<el-button style="margin-left: 20px;" size="mini" round plain @click="handleFilter('age')">确定</el-button>
					</el-form-item>
					<el-form-item label="检验结果">
						<template v-for="item in lisTagdata">
						<span :key="item.id" class="key-opt" :class="{active: filter.lisTag.indexOf(item.id) > -1}" @click="handleFilter('lisTagIds', item.id)">{{item.name}}<i class="el-icon-close"></i></span>
						</template>
					</el-form-item>
					<el-form-item label="检验结果关系">
						<el-radio-group v-model="filter.lisRelation" @change="handleFilter()">
							<el-radio :label="1">且</el-radio>
							<el-radio :label="2">或</el-radio>
						</el-radio-group>
					</el-form-item>	
					<el-form-item label="疾病标签">
						<template v-for="item in tagDisease">
						<span :key="item.tagId" class="key-opt" :class="{active: filter.diseaseTag.indexOf(item.tagId) > -1}" @click="handleFilter('diseaseTags', item.tagId)">{{item.tagName}}<i class="el-icon-close"></i></span>
						</template>
					</el-form-item>
					<el-form-item label="疾病标签关系">
						<el-radio-group v-model="filter.diseaseTagRelation" @change="handleFilter()">
							<el-radio :label="1">且</el-radio>
							<el-radio :label="2">或</el-radio>
						</el-radio-group>
					</el-form-item>	
					<!-- <el-form-item label="生活方式标签">
						<template v-for="item in tagLife">
						<span :key="item.tagId" class="key-opt" :class="{active: filter.lifeTag.indexOf(item.tagId) > -1}" @click="handleFilter('lifeTags', item.tagId)">{{item.tagName}}<i class="el-icon-close"></i></span>
						</template>
					</el-form-item>
					<el-form-item label="生活方式标签关系">
						<el-radio-group v-model="filter.lifeTagRelation" @change="handleFilter()">
							<el-radio :label="1">且</el-radio>
							<el-radio :label="2">或</el-radio>
						</el-radio-group>
					</el-form-item>	 -->
					<el-form-item label="星级客户">
						<span class="key-opt" :class="{active: filter.star == 1}" @click="handleFilter('star', 1)">重点关注<i class="el-icon-close"></i></span>
					</el-form-item>					
				</div>
				</el-form>
			</div>

			
			<div class="table-wrap">
				<div class="action-bar">
					<template v-if="multipleSelection.length === 0">
						<el-button size="mini" round disabled>修改分组</el-button>
						<!-- <el-button type="primary" size="mini" round>发问卷</el-button> -->
						<el-button size="mini" round :disabled="true">发短信</el-button>
						<el-button slot="reference" size="mini" round plain :disabled="true">移除分组</el-button>
					</template>
					<template v-else>
						<el-button type="primary" size="mini" round @click="showDlg(1)">修改分组</el-button>
						<!-- <el-button type="primary" size="mini" round>发问卷</el-button> -->
						<el-button type="primary" size="mini" round @click="showDlg(3)">发短信</el-button>
						<el-popconfirm confirmButtonText='删除' title="确定删除吗？" @confirm="delPatient">
							<el-button slot="reference" type="danger" size="mini" style="margin-left: 10px;" round plain>移除分组</el-button>
						</el-popconfirm>						
					</template>

				</div>
				<el-table ref="multipleTable"  header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading" @selection-change="selectionChange">
					<el-table-column fixed="left" type="selection" width="55"></el-table-column>
					<el-table-column fixed="left" prop="name" label="姓名" width="120">
						<template slot-scope="scope"><router-link target="_blank" :to="{name: 'Patient/User', query: {patientId: scope.row.id}}"><span class="fc key">{{ scope.row.name }}</span></router-link></template>
					</el-table-column>
					<el-table-column label="性别">
						<template slot-scope="scope">{{ scope.row.sex == '2' ? '女' : '男' }}</template>
					</el-table-column>
					<el-table-column prop="age" label="年龄" width="80">
						<template slot-scope="scope">
							<span>{{scope.row.age}}岁</span>
						</template>
					</el-table-column>
					<el-table-column prop="nation" label="民族"></el-table-column>
					<el-table-column prop="idcard" label="身份证号" width="180"></el-table-column>
					<el-table-column prop="phone" label="联系电话" width="180"></el-table-column>
					<el-table-column prop="date" label="入组时间" width="200"></el-table-column>
					<el-table-column fixed="right" label="操作" width="220">
						<template slot-scope="scope">
							<div class="tab-action">
								<el-tooltip content="查看" placement="top" :enterable="false"><router-link target="_blank"  :to="{name: 'Patient/User', query: {patientId: scope.row.id}}"><i class="icon-research"></i></router-link></el-tooltip>
								<!-- <el-tooltip content="电话" placement="top" :enterable="false"><i class="icon-tel" @click="copyMobile(scope.row)"></i></el-tooltip> -->
								<!-- <el-tooltip content="电话" placement="top" :enterable="false"><i class="icon-tel" @click="call(scope.row)"></i></el-tooltip> -->
								<el-tooltip content="短信" placement="top" :enterable="false"><i class="icon-msg" @click="showDlg(3, scope.row)"></i></el-tooltip>
								<!-- <el-tooltip content="在线沟通" placement="top" :enterable="false"><i class="icon-chat"></i></el-tooltip> -->
								<el-tooltip content="取消重点关注" placement="top" :enterable="false" v-if="scope.row.star == 1"><i class="icon-fav" @click="handleFav(scope.$index, scope.row)"></i></el-tooltip>
								<el-tooltip content="重点关注" placement="top" :enterable="false" v-else><i class="icon-fav-no" @click="handleFav(scope.$index, scope.row)"></i></el-tooltip>
							</div>
						</template>
					</el-table-column>
				</el-table>	
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>			
		</div>

		<el-dialog title="修改分组" width="530px" :visible.sync="dlg.active" :close-on-click-modal="false">
			<el-form ref="form" label-width="100px" :rules="dlg.rules" :model="form2">
				<el-form-item label="保存到" prop="newGroupId">
					<el-select size="small" filterable v-model="form2.newGroupId" placeholder="分组">
						<el-option v-for="item in groupList" :key="item.id" :label="item.groupingName" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg">关 闭</el-button>
				<el-button type="primary" :loading="isLoading" @click="changeGroup">保 存</el-button>
			</div>
		</el-dialog>	
		
		<el-dialog title="发短信" label-position="left" width="800px" :visible.sync="dlg.active3" :close-on-click-modal="false">
			<el-form ref="form3" :rules="dlg.rules3" :model="form3">
				<el-form-item label="接收人:"><div class="to-users">{{form3.users}}</div></el-form-item>
				<el-form-item label="" label-width="0" prop="content">
					<el-input type="textarea" style="width: 100%;" rows="6" resize="none" maxlength="255" placeholder="请输入短信内容,最多255个字" show-word-limit v-model="form3.content"></el-input>
					<div  v-if="smsFlag">计费条数:&nbsp;{{Math.ceil(form3.content.length/smsPrice)}}条&nbsp;&nbsp;({{ smsPrice }}字/条)</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg(1)">取 消</el-button>
				<el-button type="primary" @click="saveForm3" v-if="!isLoading">发 送</el-button>
				<el-button type="primary" :loading="true" v-else>发送中</el-button>				
			</div>
		</el-dialog>				
		
  </div>
</template>

<script>
import mixin from '@/views/mixin';
import api from '@/service/api.js';
import utils from '@/service/utils';
import dayjs from 'dayjs';

export default {
  mixins: [mixin],
//   mixins: [mixin,telMixins],
	data(){
		return {
			isExpanded: false,
			dlg: {
				active: false,
				active3: false,
				rules: {
					newGroupId: {required: true, message: '请选择分组'}
				},
				rules3: {
					content: {required: true, message: '请输入内容'}
				}
			},
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				groupingId: 0,
				name: '',
				cardNum: '',
				phone: '',
				sex: '',
				ageStart: '',
				ageEnd: '',
				star: '',
				diseaseTag: '',
				// lifeTag: '',
				diseaseTagIds: '',
				// lifeTagIds: '',
				diseaseTagRelation:1,
				// lifeTagRelation:1,
				pageNumber: 1,
				pageSize: 10,
				groupDateStart: '',
				groupDateEnd: '',
				lisTagIds:'',
				lisTag:'',
				lisRelation:1,
				date:[]
			},
			form: {
				groupingName: '',
				description: ''
			},
			form2: {
				oldGroupId: '',
				newGroupId: '',
				patientIds: []
			},
			// 短信表单
			form3: {
				users: '',
				content: '',
				shortMessageSendListPos: []
			},			
			groupList: [],
			tagDisease: [],
			tagLife: [],
			smsPrice:50,
			smsFlag:false,
			lisTagdata:[
				{
					id:1,
					name:'甲胎蛋白'
				},
				{
					id:2,
					name:'乙肝阳性'
				},
				{
					id:3,
					name:'乙肝阴性'
				},
				{
					id:4,
					name:'丙肝阳性'
				},
				{
					id:5,
					name:'丙肝阴性'
				},
				
			]

		}
	},
	async created() {
		let query = this.$route.query;
		if (query) {
			this.filter.groupingId = query.groupingId || '';
			this.filter.name = query.name || '';
			this.filter.cardNum = query.cardNum || '';
			this.filter.phone = query.phone || '';
			this.filter.sex = query.sex || '';
			this.filter.star = query.star || '';
			this.filter.ageStart = query.ageStart || '';
			this.filter.ageEnd = query.ageEnd || '';
			
			//疾病标签初始化
			this.filter.diseaseTag = query.diseaseTagIds ? query.diseaseTagIds.split(',') : [];
			this.filter.diseaseTag = this.filter.diseaseTag.map((item)=>{ return +item;});
			this.filter.diseaseTagIds = this.filter.diseaseTag.join(',');
			// //生活方式标签初始化
			// this.filter.lifeTag = query.lifeTagIds ? query.lifeTagIds.split(',') : [];
			// this.filter.lifeTag = this.filter.lifeTag.map((item)=>{ return +item;});
			// this.filter.lifeTagIds = this.filter.lifeTag.join(',');
			// 检验结果
			this.filter.lisTag = query.lisTagIds ? query.lisTagIds.split(',') : [];
			this.filter.lisTag = this.filter.lisTag.map((item)=>{ return +item;});
			this.filter.lisTagIds = this.filter.lisTag.join(',');
			this.filter.lisRelation=Number(query.lisRelation)|| 1;
			if(query.date){
				this.filter.groupDateStart = dayjs(query.date[0]).format('YYYY-MM-DD 00:00:00')
				this.filter.groupDateEnd = dayjs(query.date[1]).format('YYYY-MM-DD 23:59:59');
				this.filter.date = [this.filter.groupDateStart, this.filter.groupDateEnd];
			}
		}

		this.loadList();
		this.smsFlag=await api.getSmsFlag();
		if(this.smsFlag){
			this.smsPrice=JSON.parse(localStorage.getItem('smsInfo'))?.smsPrice;
		}
		// 患者分组 数据
		api.getPatientGroupList({}).then((res)=>{
			if (res.code == 1000 && res.data) {
				this.groupList = res.data;
			}
		});

		// 标签数据
		api.getPatientAllTag().then((res)=>{
			if (res.code == 1000 && res.data) {
				this.tagDisease = res.data.diseaseTagList;
				this.tagLife = res.data.lifeTagList;
			}
		});

	},
	methods: {
		selectionChange(selected) {
			// 覆盖掉通用的
			let selection = []
			selected.forEach((item)=>{
				selection.push(item);
			})
			this.multipleSelection = selection;
		},		
		async loadList() {
			this.isLoading = true;
			let res = await api.getGroupingPatientList(this.filter);
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}

			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				res.data.patientGroupingListVOS.forEach((item)=>{
					item.date =item.inGroupTime? dayjs(item.inGroupTime).format('YYYY-MM-DD HH:mm:ss'):'';
					// item.mobile = item.phone?.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
					item.idcard = utils.hideIdCard(item.cardNum);
				})
				this.list.data = res.data.patientGroupingListVOS;
			}
			this.pageTitle = res.data.groupingName;
			this.form2.oldGroupId = res.data.groupingId;
			this.isLoading = false;
		},		
		showDlg(v, item) {
			switch(v) {
				case 1:
					if (this.multipleSelection.length == 0) {return this.$message.warning('未选择任何数据');}
					this.dlg.active = true; 
					break;
				case 3:
					if (!item && this.multipleSelection.length == 0) {return this.$message.warning('未选择任何数据');}
					this.form3.content = '';
					if (item) {
						this.form3.shortMessageSendListPos = [{patientId: item.id, phone: item.phone}];
						this.form3.users = item.name;
					} else {
						let list = [];
						this.multipleSelection.forEach(item=>{
							list.push({patientId: item.id, phone: item.phone});
						})
						this.form3.shortMessageSendListPos = list;
						this.form3.users = this.multipleSelection.map(item=>item.name).join(', ')
					}
					this.dlg.active3 = true;
					this.$nextTick(()=>{
						this.$refs['form3'].resetFields();
					});
					break;
			}
		},
		closeDlg() {
			this.dlg.active = false;
			this.dlg.active3 = false;
		},
		changeGroup() {
			this.form2.patientIds = this.multipleSelection.map(item=>item.id).join(',');
			this.$refs['form'].validate(async (valid)=>{
				if (valid) {
					this.isLoading = true;
					let res = await api.changePatientGroup(this.form2);
					this.isLoading = false;
					if (res.code != 1000) {
						return this.$message.error(res.message);
					}
					this.$message.success('保存成功');
					this.loadList();
					this.dlg.active = false;
				}
			});
		},
		async delPatient() {
			if (this.multipleSelection.length == 0) {return this.$message.warning('未选择任何数据');}
			this.isLoading = true;
			this.form2.patientIds = this.multipleSelection.map(item=>item.id).join(',');
			let res = await api.delPatientFromGroup({groupId: this.form2.oldGroupId, patientIds: this.form2.patientIds});
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.$message.success('已删除');
			this.isLoading = false;
			this.loadList();
		},
		async saveForm3() {
			this.$refs['form3'].validate(async (valid)=>{
				if (valid) {
					this.isLoading = true;
					let res = await api.sendSMS(this.form3);
					this.isLoading = false;
					if (res.code != 1000) {return this.$message.error(res.message);}
					this.$message.success('短信发送成功');
					this.closeDlg();
					this.clearSelection();
				}
			})
		},		
		/** 重点关注 **/
		async handleFav(idx, item) {
			let res;
			this.isLoading = true;
			res = await api.getPatient({patientId: item.id});
			res.data.star = +!res.data.star;
			res = await api.editPatient(res.data);
			if (res.code != 1000) {
				this.isLoading = false;
				return this.$message.error(res.message);
			}
			this.isLoading = false;
			this.loadList();
		},
		/** 筛选状态切换 **/
		toggleCollapse() {
			this.isExpanded = !this.isExpanded;
		},
		/** 筛选 **/
		handleFilter(key, val) {
			let query;
			switch(key) {
				case 'sex':
					if (this.filter.sex == val) {this.filter.sex = '';} else {this.filter.sex = val;}
					break;
				case 'star':
					if (this.filter.star == val) {this.filter.star = '';} else {this.filter.star = val;}
					break;
				case 'diseaseTags':
					if (this.filter.diseaseTag.indexOf(val) > -1) {
						this.filter.diseaseTag.splice(this.filter.diseaseTag.indexOf(val), 1);
					} else {
						this.filter.diseaseTag.push(val);
					}
					break;
				// case 'lifeTags':
				// 	if (this.filter.lifeTag.indexOf(val) > -1) {
				// 		this.filter.lifeTag.splice(this.filter.lifeTag.indexOf(val), 1);
				// 	} else {
				// 		this.filter.lifeTag.push(val);
				// 	}
				// 	break;
				case 'search':break;
				case 2:
					if (this.filter.date) {
						this.filter.groupDateStart = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.groupDateEnd = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.groupDateStart = '';
						this.filter.groupDateEnd = '';						
					}
					break;
				case 'lisTagIds':
					if (this.filter.lisTag.indexOf(val) > -1) {
						this.filter.lisTag.splice(this.filter.lisTag.indexOf(val), 1);
					} else {
						this.filter.lisTag.push(val);
					}
					break;
			}
			console.log(this.filter,'=======vvv');

			query = JSON.parse(JSON.stringify(this.filter));
			query.diseaseTagIds = query.diseaseTag.join(',');
			// query.lifeTagIds = query.lifeTag.join(',');
			query.lisTagIds = query.lisTag.join(',');

			delete query.pageNumber;
			delete query.pageSize;
			delete query.diseaseTag;
			// delete query.lifeTag;
			delete query.lisTag;
		

			this.$router.push({name: 'Patient/GroupView', query: query});
			this.filter.diseaseTagIds = query.diseaseTagIds;
			// this.filter.lifeTagIds = query.lifeTagIds;
			this.filter.lisTagIds = this.filter.lisTag.join(',');

			this.filter.pageNumber = 1;
			this.loadList();
		},
		/** 打电话 **/
		async call(item){
				if(!item.phone) return false;
				this.isLoading = true;
				let res = await api.makePhoneCall(item.phone);
				
				if(res == "copyMobile"){
					this.copyMobile(item.phone);
					this.isLoading = false;
					return;
				} else if(res=='YS_HM4'){
					let info={
						patientId: item.id,
						relationship:0
					}
					console.log(info,item.phone,'------list-call');
					this.makeCall(item.phone,info);
					// this.makeCall(8058,'015950647684');
					this.isLoading = false;
					this.$message.success('电话呼出成功');
				} else if(res=='SD_ZQ1'||res=='ZJ_SC1'){
					this.makeCall(item.phone);
					this.isLoading = false;
					this.$message.success('电话呼出成功');
				} else if(!res){
					this.isLoading = false;
					this.$message.error('电话呼出失败');
				} 
				
		},
		copyMobile(item) {
			this.$clipboard(item.phone);
			this.$message.success('手机号码复制成功');
		},					
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		exportReport() {
			this.filter.pageSize=this.list.total;

			let url = api.exportListPatientByGrouping(this.filter);
			const tempLink = document.createElement('a');
			tempLink.style.display = 'none';
			tempLink.href = url;
			tempLink.target = '_blank';
			document.body.appendChild(tempLink);
			tempLink.click()
			document.body.removeChild(tempLink);
			this.filter.pageSize=10;

		},
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
</style>
